var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIconnotificationsexclamationpoint = function SvgIconnotificationsexclamationpoint(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Notifications/icon.notifications.exclamationpoint.white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Notifications/icon.notifications.exclamationpoint.white",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9351326,1 C36.934028,1 37.7448416,1.38034996 38.2731643,2.04774597 C38.852499,2.77958231 39.0902772,3.81602604 38.96976,4.9801211 L38.96976,4.9801211 L34.6392113,42.4978946 C34.5181403,43.5774793 34.1129973,44.4699139 33.4650005,45.0840178 C32.8346113,45.6814351 31.9824653,46 31,46 C30.0175347,46 29.1653887,45.6814351 28.5349995,45.0840178 C27.8870027,44.4699139 27.4818597,43.5774793 27.3604225,42.4946764 L27.3604225,42.4946764 L23.03024,4.98012103 C22.9097228,3.816026 23.147501,2.7795823 23.7268357,2.04774597 C24.2551584,1.38034996 25.065972,1 26.0648674,1 L26.0648674,1 Z",
    id: "!",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 30.8571429,
    cy: 56.4642857,
    r: 4.53571429
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIconnotificationsexclamationpoint);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.notifications.exclamationpoint.5c46b0663c0f7e141197db393362bb9f.svg";